import { Component, OnInit, Injector } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { LayoutService } from '../../../Services/layout/layout.service';

@Component({
	selector: 'content-border',
	template: `
		<div class="content-border" [ngClass]="control.attributes.textAlign">
			<span class="title" [innerHTML]="control.attributes.title"></span>
			<span class="subtitle"> {{ control.attributes.subtitle }} </span>
			<div class="controls-container" *ngIf="control.attributes.controls">
				<control
					*ngFor="let cntrl of control.attributes.controls"
					context="page"
					[control]="cntrl"
					[ngClass]="{
						'small-margin': cntrl.controlType === 'AddressChange',
						'bundle-btn': cntrl.name === 'ButtonLink.BackToBundle',
						'discount-checkboxes-wrapper': cntrl.name === 'DiscountOptions'
					}"
				>
				</control>
			</div>
		</div>
	`,
	styleUrls: ['./content-border.component.scss'],
})
export class ContentBorderComponent extends BaseComponent implements OnInit {
	controls;
	constructor(injector: Injector, private LayoutService: LayoutService) {
		super(injector);
	}

	ngOnInit() {
		this.LayoutService.staticLayout.subscribe((data) => {
			if (data && this.control) {
				this.control = Object.assign({}, this.control);
			}
		});
	}

	trackById(index, item) {
		return index;
	}
}
